import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";

class AbsencesReport extends Component {

    render() {

        const { reportData, startDate, endDate } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="Absences Report"
                  category={moment(startDate).format('MM/DD/YYYY') + " - " + moment(endDate).format('MM/DD/YYYY') }
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Names</th>
                          <th>Leave with Pay</th>
                          <th>Leave without Pay</th>
                          <th>AWOL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData && reportData.length > 0 
                          ? reportData.map((employee) => {
                            return (
                              <tr key={employee.employee._id}>
                                <td>{getFullName(employee.employee)}</td>
                                {employee.withPay && Object.keys(employee.withPay).length ? 
                                    <td>
                                        {
                                            Object.keys(employee.withPay).map(key=>{
                                                return <div key={key}>{`${key}: ${employee.withPay[key]}`}</div>
                                            })
                                        }
                                    </td>
                                    :
                                    <td>-</td>
                                }
                                {employee.withoutPay && Object.keys(employee.withoutPay).length ?
                                    <td>
                                        {
                                            Object.keys(employee.withoutPay).map(key=>{
                                                return <div key={key}>{`${key}: ${employee.withoutPay[key]}`}</div>
                                            })
                                        }
                                    </td>
                                    :
                                    <td>-</td>
                                }
                                {employee.awol && employee.awol.length ?
                                  <td>
                                    {
                                      employee.awol.map((instance,index) => {
                                        if (instance.period === "wholeDay") {
                                          return <span key={instance.date}>{instance.date.split('-')[2]}{index !== employee.awol.length -1 ? ", " : ""}</span>
                                        }

                                        return true;
                                      })
                                    }
                                  </td>
                                  :
                                  <td>-</td>
                                  
                                }
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='4'>No results found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default AbsencesReport;
